import { useRef } from 'react';
import { Link } from 'react-router-dom';
import Wordmark from './Wordmark';
import { usePointerVars } from './motion';
import '../../theme/marketing.css';
import '../../theme/landing.css';

/**
 * The frame the sign-in, sign-up and password screens share, in the landing
 * page's design: a brand panel on the left — the wordmark over the same
 * pointer-lit dot field the landing hero opens on, and whatever the page says
 * there — and the form card on the right, with the way back to the site.
 *
 * The panel follows the light/dark theme like the rest of the site. Below
 * 920px it folds away and the wordmark moves above the card.
 *
 * Pages keep their own form markup (.field, .sub, .auth-msg, .auth-alt);
 * theme/landing.css styles it under the shell's root.
 */
export default function AuthShell({ aside, children }) {
  const sideRef = useRef(null);
  usePointerVars(sideRef);
  return (
    <div id="lp" className="lx-page lx-authpage">
      <div className="lx-auth">
        <aside className="lx-auth-side" ref={sideRef}>
          <div className="lx-dots" aria-hidden="true"><i /></div>
          <div className="lx-auth-glow" aria-hidden="true" />
          <Wordmark />
          {aside}
        </aside>
        <main className="lx-auth-main">
          <div className="lx-auth-top">
            <span className="lx-auth-mark"><Wordmark /></span>
            <Link to="/" className="lx-auth-back"><span aria-hidden="true">←</span> Back to the site</Link>
          </div>
          <div className="lx-auth-card">{children}</div>
        </main>
      </div>
    </div>
  );
}
